module.exports = __webpack_public_path__ + "img/1-complexity.4783c37e.svg";